import { useMemo } from "react";
import moment from "moment";

/**
 * Returns true when the promo's endDate is in the past.
 * Mirrors the same date-based logic used in CasinoStatusProvider.
 */
const useIsPromoCompleted = (endDate: string | null | undefined): boolean => {
  return useMemo(() => !!endDate && moment().isAfter(moment(endDate)), [endDate]);
};

export default useIsPromoCompleted;
